import type { StandardSchemaV1 } from "@t3-oss/env-core";

/** Report authored validation descriptions, never raw issues or submitted values. */
export function invalidEnv(service: string, issues: readonly StandardSchemaV1.Issue[]): never {
  const descriptions = issues.map((issue) => {
    const path = issue.path?.map((part) => String(typeof part === "object" ? part.key : part));
    return `${path?.join(".") ?? "environment"}: ${issue.message}`;
  });
  throw new Error(`Invalid ${service} configuration: ${descriptions.join("; ")}`);
}
